export default __webpack_public_path__ + "static/media/compas_project_download_attestation.21fb319e.gif";